import { createLocation, createPath } from 'history'
import queryString from 'query-string'
import { isServer } from './isServer'

/* ---------------------------------- */

const getCurrentOrigin = () => {
  if (!isServer()) {
    if (document.location.origin) {
      return document.location.origin
    } else {
      return `${document.location.protocol}//${document.location.host}`
    }
  }
  return ''
}

const extractKeyFromQuery = (url, name) => {
  const query = url && url.split('?')[1]
  const search = query && query.split('#')[0]

  if (search) {
    return queryString.parse(search)[name]
  }
  return ''
}

const makeUrl = (baseUri, params = {}) => {
  const location = createLocation(baseUri)
  const searchMap = {
    ...params,
    ...queryString.parse(location.search),
  }

  const url = createPath({
    ...location,
    search: queryString.stringify(searchMap)
  })

  return url
}

const isAbsolutePath = path => /^((https?):\/\/|\/\/)/.test(path)

const parseSearch = obj => {
  let str

  if (typeof obj === 'string') {
    str = obj
  } else if (typeof obj === 'object') {
    str = Object.keys(obj).map(key => {
      const value = obj[key]
      if (value !== undefined) {
        return `${key}=${encodeURIComponent(value)}`
      }
      return key
    }).join('&')
  }

  if (str) {
    return str.charAt(0) === '?' ? str : `?${str}`
  }

  return undefined
}

const parseHash = str => {
  if (str) {
    return str.charAt(0) === '#' ? str : `#${str}`
  }

  return undefined
}

/* ---------------------------------- */

export {
  isAbsolutePath,
  parseSearch,
  parseHash,
  getCurrentOrigin,
  makeUrl,
  extractKeyFromQuery
}

